import axios from "axios";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";

import store from "../store";
import { updatestate } from "store/reducer";
import {
  BASE_URL,
  SELLER_REF,
  CAMPAIGN_REF,
  TRACK_TOKEN,
} from "../constants";
import router from "routes/router";

import { ErrorAlert } from "components";
import logger from "utils/logger";


/**
 * @param {string} endpoint
 * @param {RawAxiosRequestConfig<any>} axiosConfig
 * @param {{ showErrorPopup: boolean }} showErrorPopup
 * @returns {Promise<[boolean, any]>} request
 */
const baseQuery = async (endpoint, axiosConfig, { showErrorPopup }) => {
  const request = await axios(axiosConfig)
    .then((res) => {
      logger.log(endpoint, "response", res.data);

      if (res.data.statusCode === 200) {
        return [true, res.data.data];
      } else {
        if (showErrorPopup) {
          confirmAlert({
            customUI: ({ onClose }) =>
              ErrorAlert({
                onClose,
                error:
                  typeof res.data?.message !== "object"
                    ? res.data?.message
                    : JSON.stringify(res.data?.message),
                serverError: true,
              }),
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
        }

        return [false, res.data];
      }
    })
    .catch((error) => {
      confirmAlert({
        customUI: ({ onClose }) =>
          ErrorAlert({
            onClose,
            error:
              typeof error.reponse.message !== "object"
                ? error.response.message
                : JSON.stringify(error.response.message),
            serverError: true,
          }),
        closeOnEscape: false,
        closeOnClickOutside: false,
      });

      return [false, error.response];
    });

  return request;
};

export function createBookingBody({
  ticketFields,
  reduxstate,
  paid,
  classPhoto,
  eventOrganizer,
  selectedDate,
  isPrivate,
  bookingCode,
  bookingsReservationId,
  paymentStatus,
  paymentMethod,
  paymentMode,
}) {
  let eventDetails = {
    classPhoto,
    eventOrganizer,
    selectedDate,
  };

  const val = localStorage.getItem("eventDetails");

  if (val && !classPhoto) {
    eventDetails = JSON.parse(val);
  } else {
    localStorage.setItem("eventDetails", JSON.stringify(eventDetails));
  }

  logger.log("AddParticipant-Event Details", eventDetails);
  logger.log("Redux in create event", reduxstate);

  const mod_ticketFields = [];
  ticketFields?.selectedEventPricing?.map((item) => {
    if (item?.bookingQty > 0) {
      mod_ticketFields.push({
        bookingQty: item?.bookingQty,
        totalPrice: item?.totalPrice,
        ticketType: item?.ticketType,
        serviceFee: !item?.absorbServiceFee
          ? Number(item?.serviceFee) * item?.bookingQty
          : 0,
        ticketAmount: Number(item.amount),
      });
    }
  });

  logger.log("AddParticipant-Event Details", eventDetails);

  const sellerRef = window.localStorage.getItem(SELLER_REF);
  const campaignRef = window.localStorage.getItem(CAMPAIGN_REF);
  const trackToken = window.localStorage.getItem(TRACK_TOKEN);

  const body = {
    eventScheduleId: reduxstate.id,
    type: "add",
    isPackage: false,
    isEvent: reduxstate.eventData.isEvent,
    username: `+${ticketFields.username}`,
    fullName: ticketFields.fullName,
    email: ticketFields.email,
    isPaid: paid ? true : false,
    selectedEventPricing: mod_ticketFields,
    selectedAddonsPricing: ticketFields.addonsPricingList
      .filter((addon) => "bookingQty" in addon && addon.bookingQty !== 0)
      .map((addon) => ({
        bookingQty: addon.bookingQty,
        totalPrice: addon.totalPrice,
        id: addon.id,
      })),
    bookingId: ticketFields.orderReferenceId,
    ...(isPrivate && { bookingCode }),
    bookingsReservationId,
    paymentStatus,
    paymentMethod,
    paymentMode,
    ...sellerRef !== undefined && sellerRef && sellerRef !== "" ? { sellerReferenceId: sellerRef } : {},
    ...sellerRef && campaignRef && campaignRef !== "" ? { campaignId: campaignRef } : {},
    ...(trackToken && trackToken !== "" ? { trackToken } : {}),
    ...(ticketFields.dietaryPreferences && ticketFields.dietaryPreferences.length > 0
      ? { dietaryPreferences: ticketFields.dietaryPreferences }
      : {}),
  };

  return body;
}

export const addParticipant = async ({
  ticketFields,
  reduxstate,
  setLoading,
  setbookingconfirmed,
  paid,
  totalPrice,
  setopenTikkiePaymentModal,
  classPhoto,
  eventOrganizer,
  selectedDate,
  isPrivate,
  bookingCode,
  bookingsReservationId,
  paymentStatus,
  paymentMethod,
  paymentMode,
}) => {
  let eventDetails = {
    classPhoto,
    eventOrganizer,
    selectedDate,
  };

  const val = localStorage.getItem("eventDetails");

  if (val && !classPhoto) {
    eventDetails = JSON.parse(val);
  } else {
    localStorage.setItem("eventDetails", JSON.stringify(eventDetails));
  }

  logger.log("AddParticipant-Event Details", eventDetails);

  if (setLoading) {
    setLoading(true);
  }
  const mod_ticketFields = [];
  ticketFields.selectedEventPricing?.map((item) => {
    if (item?.bookingQty > 0) {
      mod_ticketFields.push({
        bookingQty: item?.bookingQty,
        totalPrice: item?.totalPrice,
        ticketType: item?.ticketType,
        serviceFee: !item?.absorbServiceFee
          ? Number(item?.serviceFee) * item?.bookingQty
          : 0,
        ticketAmount: Number(item.amount),
      });
    }
  });
  const ticketsObject = mod_ticketFields.reduce(
    (acc, ticket, idx) => ({
      ...acc,
      [`bookingQty${idx + 1}`]: `${ticket.bookingQty} x`,
      [`ticketType${idx + 1}`]: ticket.ticketType,
      [`ticketTotalPrice${idx + 1}`]: `€ ${ticket.totalPrice}`,
    }),
    {}
  );
  const totalFees = mod_ticketFields.reduce((acc, ticket) => {
    if (!ticket.absorbServiceFee) {
      return acc + parseFloat(ticket.serviceFee);
    } else {
      return acc;
    }
  }, 0);

  logger.log("AddParticipant-Event Details", eventDetails);
  const sellerRef = window.localStorage.getItem(SELLER_REF);
  const campaignRef = window.localStorage.getItem(CAMPAIGN_REF);
  const trackToken = window.localStorage.getItem(TRACK_TOKEN);
  const body_old = {
    eventScheduleId: reduxstate.id,
    type: "add",
    isPackage: false,
    isEvent: reduxstate.eventData.isEvent,
    username: `+${ticketFields.username}`,
    fullName: ticketFields.fullName,
    email: ticketFields.email,
    isPaid: paid ? true : false,
    selectedEventPricing: mod_ticketFields,
    selectedAddonsPricing: ticketFields.addonsPricingList
      .filter((addon) => "bookingQty" in addon && addon.bookingQty !== 0)
      .map((addon) => ({
        bookingQty: addon.bookingQty,
        totalPrice: addon.totalPrice,
        id: addon.id,
      })),
    bookingId: ticketFields.orderReferenceId,
    ...(isPrivate && { bookingCode }),
    bookingsReservationId,
    paymentStatus,
    paymentMethod,
    paymentMode,
    ...sellerRef !== undefined && sellerRef && sellerRef !== "" ? { sellerReferenceId: sellerRef } : {},
    ...sellerRef && campaignRef && campaignRef !== "" ? { campaignId: campaignRef } : {},
    ...(trackToken && trackToken !== "" ? { trackToken } : {}),
  };
  const body = {
    eventScheduleId: reduxstate.id,
    // username: `+${ticketFields.username}`,
    // fullName: ticketFields.fullName,
    // email: ticketFields.email,
    consumerUsername: `+${ticketFields.username}`,
    consumerFullname: ticketFields.fullName,
    consumerEmail: ticketFields.email,
    selectedEventPricing: mod_ticketFields,
    selectedAddonsPricing: ticketFields.addonsPricingList
      .filter((addon) => "bookingQty" in addon && addon.bookingQty !== 0)
      .map((addon) => ({
        bookingQty: addon.bookingQty,
        totalPrice: addon.totalPrice,
        id: addon.id,
      })),
    // bookingId: ticketFields.orderReferenceId,
    ...(isPrivate && { bookingCode }),
    bookingsReservationId,
    // paymentStatus,
    paymentMethod,
    // paymentMode,
    ...sellerRef !== undefined && sellerRef && sellerRef !== "" ? { sellerReferenceId: sellerRef } : {},
    ...sellerRef && campaignRef && campaignRef !== "" ? { campaignId: campaignRef } : {},
    ...(trackToken && trackToken !== "" ? { trackToken } : {}),
  };

  try {
    const config = {
      method: "post",
      // url: BASE_URL + "/addEventBooking", replace with new oder place
      url: BASE_URL + "/payments/orderPlace",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
    };
    axios(config)
      .then(async function (response) {
        logger.log("add participant response...", response.data);

        if (response.data.statusCode !== 200) {
          logger.log("error addParticipant", response.data);
          confirmAlert({
            customUI: ({ onClose }) =>
              ErrorAlert({
                onClose,
                error: response.data.message,
                serverError: true,
              }),
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
          if (setLoading) {
            setLoading(false);
          }

          return;
        }

        store.dispatch(updatestate({ reservationId: "" }));
        router.navigate(
          "/order-confirmation/" +
          reduxstate.eventData?.eventDetail.eventName.replace(/\s+/g, "-").toLowerCase() +
          "/" +
          reduxstate.eventData.referenceId +
          "/" +
          response.data?.data.bookingInfo.bookingId,
          { replace: true }
        );
      })
      .catch(function (error) {
        logger.log(error);
        confirmAlert({
          customUI: ({ onClose }) =>
            ErrorAlert({ onClose, error: error.message, serverError: true }),
          closeOnEscape: false,
          closeOnClickOutside: false,
        });
        if (setLoading) {
          setLoading(false);
        }
      });
  } catch (error) {
    logger.log("error....", error);
    confirmAlert({
      customUI: ({ onClose }) =>
        ErrorAlert({ onClose, error: error.message, serverError: true }),
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
    if (setLoading) {
      setLoading(false);
    }
  }
};

export const addParticipantToEvent = async (body) => {
  logger.log("body in addParticipant", body);
  const mod_ticketFields = [];
  body?.ticketFields?.selectedEventPricing?.map((item) => {
    if (item?.bookingQty > 0) {
      mod_ticketFields.push({
        bookingQty: item?.bookingQty,
        totalPrice: item?.totalPrice,
        ticketType: item?.ticketType,
        serviceFee: item?.serviceFee,
        ticketAmount: Number(item.amount),
      });
    }
  });

  const sellerRef = window.localStorage.getItem(SELLER_REF);
  const campaignRef = window.localStorage.getItem(CAMPAIGN_REF);
  const trackToken = window.localStorage.getItem(TRACK_TOKEN);

  const data = {
    eventScheduleId: body.scheduleClassId,
    type: "add",
    isPackage: false,
    isEvent: body.isEvent,
    username: `+${body.ticketFields.username}`,
    fullName: body.ticketFields.fullName,
    email: body.ticketFields.email,
    isPaid: true,
    selectedEventPricing: mod_ticketFields,
    selectedAddonsPricing: body.ticketFields.addonsPricingList
      .filter((addon) => "bookingQty" in addon && addon.bookingQty !== 0)
      .map((addon) => ({
        bookingQty: addon.bookingQty,
        totalPrice: addon.totalPrice,
        id: addon.id,
      })),
    // bookingId: body.ticketFields.orderReferenceId,
    bookingId: body.bookingId,
    ...(body.isPrivate && { bookingCode: body.bookingCode }),
    bookingsReservationId: body.bookingsReservationId,
    paymentMethod: body.paymentMethod,
    paymenthMode: body.paymentMode,
    paymentStatus: body.paymentStatus,
    ...sellerRef !== undefined && sellerRef && sellerRef !== "" ? { sellerReferenceId: sellerRef } : {},
    ...sellerRef && campaignRef && campaignRef !== "" ? { campaignId: campaignRef } : {},
    ...(trackToken && trackToken !== "" ? { trackToken } : {}),
  };

  const config = {
    method: "post",
    url: BASE_URL + "/addEventBooking",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  const request = await baseQuery("addParticipant", config, {
    showErrorPopup: true,
  });

  return request;
};

export const sendConfirmationEmail = async (body) => {
  const { ticketFields, eventDetails, addParticipantresponse, reduxstate } =
    body;

  const mod_ticketFields = [];
  ticketFields.selectedEventPricing?.map((item) => {
    if (item?.bookingQty > 0) {
      mod_ticketFields.push({
        bookingQty: item?.bookingQty,
        totalPrice: item?.totalPrice,
        ticketType: item?.ticketType,
        serviceFee: item?.serviceFee,
        ticketAmount: Number(item.amount),
      });
    }
  });
  const ticketsObject = mod_ticketFields.reduce(
    (acc, ticket, idx) => ({
      ...acc,
      [`bookingQty${idx + 1}`]: `${ticket.bookingQty} x`,
      [`ticketType${idx + 1}`]: ticket.ticketType,
      [`ticketTotalPrice${idx + 1}`]: `€ ${ticket.totalPrice}`,
    }),
    {}
  );
  const totalFees = mod_ticketFields.reduce(
    (acc, ticket) => acc + parseFloat(ticket.serviceFee),
    0
  );
  const addonsObject = ticketFields.addonsPricingList.length
    ? ticketFields.addonsPricingList
      .filter((addon) => "bookingQty" in addon && addon.bookingQty > 0)
      .reduce(
        (acc, curr, idx) => ({
          ...acc,
          [`addonQty${idx + 1}`]: `${curr.bookingQty} x`,
          [`addonName${idx + 1}`]: curr.addonName,
          [`addonTotalPrice${idx + 1}`]: `€ ${curr.totalPrice}`,
        }),
        {}
      )
    : {};

  const data = {
    toName: ticketFields.fullName,
    toEmail: ticketFields.email,
    bookingType: "event",
    fromName: addParticipantresponse?.bookingInfo?.businessName,
    variables: {
      customer_name: ticketFields.fullName,
      eventPhoto: eventDetails.classPhoto,
      eventName: reduxstate.eventData.eventName,
      eventDate: `${moment(reduxstate?.eventDate).format("dddd, MMMM Do")}`,
      eventTime: `${moment(reduxstate?.eventDate).format("h:mm A")} - ${moment(
        reduxstate?.eventEndDate
      ).format("h:mm A")}`,
      eventLocation: reduxstate.location.addressName,
      eventAddress: reduxstate.location.address,
      eventOrganizer: eventDetails.eventOrganizer,
      ...ticketsObject,
      ...addonsObject,
      serviceFee: `€ ${addParticipantresponse?.bookingInfo?.totalPaymentServiceFee}`,
      totalPayableAmount: `€ ${Number(
        addParticipantresponse?.bookingInfo?.totalStripeAmount
      ).toFixed(2)}`,
      paymentMethod: addParticipantresponse?.bookingInfo?.paymentMethod,
      bookingId: addParticipantresponse?.bookingInfo?.bookingId,
      paymentStatus: addParticipantresponse?.bookingInfo?.paymentStatus,
      manageBookingUrl: addParticipantresponse?.bookingInfo?.manageBookingUrl,
      mapUrl: "https://www.google.com/maps/dir//" + reduxstate.location.address,
      downloadTickets:
        (process.env.REACT_APP_ENVIRONMENT === "STAGING"
          ? "https://devshop.tikitly.com/get-ticket/"
          : "https://shop.tikitly.com/get-ticket/") +
        addParticipantresponse?.bookingInfo?.manageBookingToken,
    },
  };

  const config = {
    method: "post",
    url: BASE_URL + "/sendBookingConfirmation",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  const request = await baseQuery("sendBookingConfirmation", config, {
    showErrorPopup: true,
  });

  return request;
};
